import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import merge from 'lodash.merge';
import RaisedButton from 'material-ui/RaisedButton';
import * as styles from './Button.scss';
import { connect } from 'react-redux';
var PrimaryButton = (_dec = connect(function (state, ownProps) {
  return {
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(PrimaryButton, _Component);

  var _super = _createSuper(PrimaryButton);

  function PrimaryButton() {
    _classCallCheck(this, PrimaryButton);

    return _super.apply(this, arguments);
  }

  _createClass(PrimaryButton, [{
    key: "render",
    value: function render() {
      var style = merge({}, {
        borderRadius: 4,
        minWidth: 120
      }, this.props.style);

      var cleanProps = _objectSpread({}, this.props);

      delete cleanProps.theme;
      delete cleanProps.shortButton;
      delete cleanProps.store;
      return /*#__PURE__*/React.createElement(RaisedButton, _extends({
        backgroundColor: this.props.theme.colors.primaryColor,
        className: styles.button,
        fullWidth: true,
        label: this.props.label,
        onSubmit: this.props.onSubmit,
        onClick: this.props.onClick,
        primary: true,
        style: style,
        type: this.props.type
      }, cleanProps));
    }
  }]);

  return PrimaryButton;
}(Component), _defineProperty(_class2, "propTypes", {
  label: PropTypes.string,
  style: PropTypes.object,
  onSubmit: PropTypes.func,
  onClick: PropTypes.func,
  type: PropTypes.string
}), _defineProperty(_class2, "defaultProps", {
  label: 'Submit',
  style: {},
  onSubmit: null,
  onClick: undefined,
  type: 'submit'
}), _temp)) || _class);
export { PrimaryButton as default };